// Role configuration for the application
export const ROLES = {
  ADMIN: 'admin',
  BILLING: 'billing',
  THERAPIST: 'therapist',
  ASSOCIATE: 'associate',
  VIEWER: 'viewer',
  CLIENT: 'client'
};

// User type for future distinction between therapists and billing
export const USER_TYPES = {
  BILLING: 'billing',
  THERAPIST: 'therapist',
  ADMIN: 'admin'
};

// Navigation configuration for each role
export const ROLE_NAVIGATION = {
  [ROLES.ADMIN]: [
    { id: 'intake-preview', label: 'Intake Preview', path: '/intake-preview' },
    { id: 'my-clients', label: 'Clients', path: '/my-clients' },
    { id: 'associates', label: 'Therapists', path: '/associates' },
    { id: 'billing', label: 'Billing', path: '/billing' },
    { id: 'admin', label: 'Admin', path: '/admin' },
    { id: 'clinical-forms', label: 'Clinical Forms', path: '/clinical-forms' },
    { id: 'informed-consent', label: 'Informed Consent', path: '/informed-consent' }
  ],
  [ROLES.CLIENT]: [
    { id: 'portal',  label: 'My Portal',      path: '/client-interface' },
    { id: 'intake',  label: 'Client Intake',  path: '/intake' },
    { id: 'self-assessment', label: 'Self-Assessment', path: '/self-assessment' },
    { id: 'informed-consent', label: 'Informed Consent', path: '/informed-consent' }
  ],
  [ROLES.BILLING]: [
    { id: 'billing', label: 'Billing', path: '/billing' },
    { id: 'my-clients', label: 'My Clients', path: '/my-clients' },
    { id: 'associates', label: 'Associates', path: '/associates' },
    { id: 'informed-consent', label: 'Informed Consent', path: '/informed-consent' }
  ],
  [ROLES.THERAPIST]: [
    { id: 'intake-preview', label: 'Intake Preview', path: '/intake-preview' },
    { id: 'my-clients', label: 'My Clients', path: '/my-clients' },
    { id: 'informed-consent', label: 'Informed Consent', path: '/informed-consent' }
  ],
  // Reserved for future use. These roles intentionally have no navigation or
  // application access until their responsibilities are formally defined.
  [ROLES.ASSOCIATE]: [],
  [ROLES.VIEWER]: []
};

// Role display names (what users see)
export const ROLE_DISPLAY_NAMES = {
  [ROLES.ADMIN]: 'Administrator',
  [ROLES.BILLING]: 'Billing Specialist',
  [ROLES.CLIENT]: 'Client',
  [ROLES.THERAPIST]: 'Therapist',
  [ROLES.ASSOCIATE]: 'Associate',
  [ROLES.VIEWER]: 'Viewer'
};

// Helper function to get navigation items for a role
export const getNavigationForRole = (role) => {
  return ROLE_NAVIGATION[role] || [];
};

// Helper function to get display name for a role
export const getRoleDisplayName = (role) => {
  return ROLE_DISPLAY_NAMES[role] || 'Unknown';
};

// Helper function to check if user is billing
export const isBillingUser = (user) => {
  return user?.role === ROLES.BILLING;
};

// Helper function to check if user is therapist
export const isTherapistUser = (user) => {
  return user?.role === ROLES.THERAPIST;
};

// Helper function to check if user has admin-level access (admin or billing)
export const hasAdminAccess = (user) => {
  return user?.role === ROLES.ADMIN || user?.role === ROLES.BILLING;
};
